import { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import NavDrawer from './NavDrawer';

interface AppShellProps {
  children: React.ReactNode;
  showBack?: boolean;
  backTo?: string;
  title?: string;
}

export default function AppShell({ children, showBack, backTo = '/', title }: AppShellProps) {
  const [menuOpen, setMenuOpen] = useState(false);
  const navigate = useNavigate();

  return (
    <>
      <div className="min-h-[100dvh] flex flex-col">
        <header className="sticky top-0 w-full z-50 px-6 py-4 grid grid-cols-3 items-center bg-deep-purple/80 backdrop-blur-md border-b border-white/10">
          <div className="justify-self-start">
            {showBack && (
              <Link
                to={backTo}
                className="p-1.5 -ml-1.5 rounded-lg hover:bg-white/10 transition-colors inline-flex"
                aria-label="Go back"
              >
                <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                  <path strokeLinecap="round" strokeLinejoin="round" d="M15 19l-7-7 7-7" />
                </svg>
              </Link>
            )}
          </div>
          <div className="justify-self-center flex items-center gap-2">
            <span className="text-2xl">🔥</span>
            <span className="font-extrabold text-xl tracking-tight">
              {title ?? 'OurSexQuiz'}
            </span>
          </div>
          <div className="justify-self-end">
            <button onClick={() => setMenuOpen(true)} className="nav-menu-trigger" aria-label="Open menu">
              <svg
                aria-hidden="true"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <path d="M4 7h16" />
                <path d="M4 12h16" />
                <path d="M4 17h16" />
              </svg>
            </button>
          </div>
        </header>

        <main className="flex-1">
          {children}
        </main>
      </div>

      <NavDrawer
        isOpen={menuOpen}
        onClose={() => setMenuOpen(false)}
        contactHref="/?contact=1"
        onPrimaryAction={() => navigate('/#onboarding')}
        primaryActionLabel="Start Quiz"
      />
    </>
  );
}
